import { AD_CLIENT_ID, AD_AUTHORITY } from "./config";

// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognitoexport

export const msalConfig = {
    auth: {
        clientId: AD_CLIENT_ID,
        authority: AD_AUTHORITY,
        knownAuthorities: [],
        postLogoutRedirectUri: window.location.protocol + '//' + window.location.host + "/login",
        redirectUri: window.location.protocol + '//' + window.location.host + "/app/dashboard",
        navigateToLoginRequestUrl: false
    },
    cache: {
        storeAuthStateInCookie: isIE || isEdge || isFirefox
    },
    system: {
        loggerOptions: {
        }
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ["offline_access", "openid", "profile"]
};